import React from 'react';
import { func, string } from 'prop-types';
import { Link } from 'react-router';

import cx from 'classnames';
import s from './User.css';
import UserBadge from '../UserBadge/UserBadge';


const MAX_NAME_LENGTH = 14;

// Displays details about the current User.
// Hiding the logout button defaults to true so as to prevent the weird transition of showing and then immediately
// hiding the button when you hit refresh if button must be not be shown for this portal instance.
const User = ({ className, closeMainMenu, firstName = '', lastName = '', hideLogoutButton = true }) => {
  let name, firstInitial, lastInitial;
  if (firstName && lastName) {
    firstInitial = firstName.charAt(0);
    lastInitial = lastName.charAt(0);
    if (firstName.length + lastName.length > MAX_NAME_LENGTH) {
      name = firstName + ' ' + lastInitial + '.';

    } else {
      name = firstName + ' ' + lastName;
    }
  } else if (firstName) {
    firstInitial = firstName.charAt(0);
    name = firstName;
  } else if (lastName) {
    lastInitial = lastName.charAt(0);
    name = lastName;
  }

  return (
    <div className={cx(s.component, className)}>
      <UserBadge
        className={s.userBadge}
        firstInitial={firstInitial}
        lastInitial={lastInitial}
      />
      <div className={cx(s.flex, s.info)}>
        <h2 className={s.primaryText}>
          {name}
        </h2>
        <Link
          to="/logout"
          title="Logout of your Patient Portal"
          id={`Logout ${firstName} ${lastName}`}
          className={hideLogoutButton ? s.hiddenAction : s.action}
          onClick={closeMainMenu}
        >
          Log out
        </Link>
      </div>
    </div>
  );

};

User.propTypes = {
  closeMainMenu: func,
  firstName: string,
  lastName: string,
};

export default User;



// WEBPACK FOOTER //
// ./src/components/User/User.js